import React, { memo, useCallback, KeyboardEvent } from 'react'
import styles from '../styles.module.scss'
import mobileCheckIcon from 'src/assets/icons/mobile-selection-check.svg'

type ColumnPattern =
  | 'col1-size1'
  | 'col1-size2'
  | 'col1-size3'
  | 'col2-size'
  | 'col3-size1'
  | 'col3-size2'
  | 'col3-size3'

export interface IFlower {
  imageUrl: string
  label: string
  name: string
  id: number
}

interface FlowerItemProps {
  flower: IFlower
  index: number
  isSelected: boolean
  sizeClass: ColumnPattern
  onSelect: (index: number) => void
}

/* eslint-disable react/prop-types */
const FlowerItem = memo<FlowerItemProps>(({ flower, index, isSelected, sizeClass, onSelect }) => {
  const handleKeyPress = useCallback(
    (e: KeyboardEvent<HTMLDivElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault()
        onSelect(index)
      }
    },
    [index, onSelect]
  )

  return (
    <div
      className={`${styles.gridItem} ${styles[sizeClass]} ${isSelected ? styles.selected : ''}`}
      onClick={() => onSelect(index)}
      onKeyPress={handleKeyPress}
      role="button"
      tabIndex={0}
      aria-label={`Select ${flower.name}`}
      aria-pressed={isSelected}
    >
      <img src={flower.imageUrl} alt={flower.label} loading="lazy" />
      <div className={styles.overlay}>
        <span>{flower.label}</span>
      </div>
      {isSelected && <img src={mobileCheckIcon} alt="Selected" className={styles.mobileCheckIcon} />}
    </div>
  )
})

FlowerItem.displayName = 'FlowerItem'

export default FlowerItem
